import {booleanAttribute, Component, computed, inject, input, output } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { VulcanIconComponent } from '@eagle-i/vulcan-component-library';
import { AppService } from '../../../../services/app.service';
import { SanitizePipe } from '../../../../shared/pipes/sanitize.pipe';
import { Report } from '../../classes/report';

@Component({
  selector: 'tgrid-report-header',
  imports: [
    MatButton,
    SanitizePipe,
    VulcanIconComponent,
  ],
  template: `<div class="report-title-bar">
    <div class="title-bar">
      <div class="name">
        <vulcan-icon size="42px" icon="folders" weight="fill"></vulcan-icon>
        <h2>
          @if (!hideState()) { {{ stateName() }} } {{report().displayName}}</h2>
      </div>
      <div class="action-buttons">
        <button mat-stroked-button (click)="export.emit('csv')">
          <vulcan-icon size="24px" icon="file-csv"></vulcan-icon>
        </button>
      </div>
    </div>

    @if (report().description) {
      <div class="subtitle" [innerHTML]="report().description | sanitize"></div>
    }
  </div>`,
  styles: `
    :host {
      display: block;
    }
    .report-title-bar {
      & div.title-bar {
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 1rem;
        margin-bottom: 24px;

        & div.name {
          display: flex;
          align-items: center;
          gap: 12px;

          vulcan-icon {
            color: var(--primary-image-color);
          }

          & h2 {
            line-height: 120%; /* 48px */
            letter-spacing: -0.8px;
            margin: 0;
          }
        }

        & div.action-buttons {
          display: flex;
          gap: 8px;

        }
      }

      & div.subtitle {
        margin-bottom: 40px;
      }
    }
  `,
})
export class ReportHeaderComponent {

  public hideState = input(false, { transform: booleanAttribute });

  private states = inject(AppService).selectedStates();
  public report = input.required<Report>();
  protected stateName = computed(() => {
    if (this.states.length === 1) {
      return this.states[0].name;
    } else if (this.states.length > 1) {
      return this.states.map(s => s.abbreviation).join(',');
    }
    return '';
  });

  public export = output<string>();


}
